import React, { useEffect, useState, useRef } from "react";
import { Helmet } from "react-helmet";
import { withTranslation } from "react-i18next";
import { connect, useSelector } from "react-redux";
import { withRouter } from "react-router-dom";
import { PageTitle } from "../../common";
import "./CommissionReport.scss";
import companyName from "../../../../store/mobxStore/companyName";
import OrderService from "../../../../service/orderHistory/orderHistory";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import "react-datepicker/dist/react-datepicker.css";
import Tiles from "./Tiles";
import Content from "./Content";
import Spinner from "../../../shared/Spinner";
import moment from "moment";

const mapStateToProps = (state) => ({ lang: state.Lang });

const CommissionReport = (props) => {
  const { t } = props;
  const [commissionData, setCommissionData] = useState([]);
  const [commissionTypes, setcommissionTypes] = useState([]);
  const [filtersChanged, setFiltersChanged] = useState(false);
  const [tiles, SetTiles] = useState([]);
  let service = new OrderService();
  let history = useHistory();
  const { location } = useHistory();
  console.log("history", location);
  const initialCommissionType = location.state?.data
    ? [location.state.data]
    : ["fastStartCommission"];
  const [selectedCommissionType, setSelectedCommissionType] = useState(
    initialCommissionType
  );
  const [state, setState] = useState({
    totalRows: 0,
    data: [],
    pending: true,
    perPage: 10,
    inPage: 1,
    types: [],
    start_date: moment().startOf("month").format("YYYY-MM-DD"),
    end_date: moment().format("YYYY-MM-DD"),
    selectedStartDate: moment().startOf("month").format("YYYY-MM-DD"),
    selectedEndDate: moment().format("YYYY-MM-DD"),
  });
  const selectedStartDateRef = useRef(state.selectedStartDate);
  const selectedEndDateRef = useRef(state.selectedEndDate);
  const perPageRef = useRef(state.perPage);
  const [printloader, setPrintLoader] = useState({
    search: false,
    reset: false,
    excel: false,
    csv: false,
    print: false,
  });

  const changeDate = (start, end, type = ["fastStartCommission"]) => {
    setSelectedCommissionType(type);
    selectedStartDateRef.current = start;
    selectedEndDateRef.current = end;
    // Convert start and end to moment objects
    // const newStartDate = moment(start).format("YYYY-MM-DD");
    // const newEndDate = moment(end).format("YYYY-MM-DD");
    setState((prevState) => ({
      ...prevState,
      start: start,
      end: end,
      selectedStartDate: start,
      selectedEndDate: end,
    }));
    // setState({
    //   ...state,
    //   start: start,
    //   end: end,
    //   selectedStartDate: start,
    //   selectedEndDate: end,
    // });
    // Update state using the setState callback
    // setState((prevState) => ({
    //   ...prevState,
    //   start_date: newStartDate,
    //   end_date: newEndDate,
    // }));

    const urlSearchParams = new URLSearchParams(location.search);
    urlSearchParams.set("type", type.join(","));
    const newQueryString = urlSearchParams.toString();
    history.push({ search: newQueryString });

    // Call fetchReport with the updated date values
    fetchReport(state.inPage, perPageRef.current, type, start, end);
  };

  const resetdata = () => {
    selectedStartDateRef.current = moment()
      .startOf("month")
      .format("YYYY-MM-DD");
    selectedEndDateRef.current = moment().format("YYYY-MM-DD");
    perPageRef.current = 10;
    setSelectedCommissionType(["fastStartCommission"]);
    setState((prev) => ({
      ...prev,
      start_date: moment().startOf("month").format("YYYY-MM-DD"),
      end_date: moment().format("YYYY-MM-DD"),
      selectedStartDate: moment().startOf("month").format("YYYY-MM-DD"),
      selectedEndDate: moment().format("YYYY-MM-DD"),
    }));
    // getReport();
    fetchReport(state.inPage, state.perPage, ["fastStartCommission"]);
  };

  const getReport = (
    inPage = state.inPage,
    perPage = state.perPage,
    selectedType = selectedCommissionType,
    start_date = state.start_date,
    end_date = state.end_date
  ) => {
    setFiltersChanged(true);
    setState({
      ...state,
      loading: true,
    });
    let start = (inPage - 1) * perPage;
    console.log(selectedType, "selectedType");
    service
      .getCommissionReport(start, perPage, selectedType, start_date, end_date)
      .then((res) => {
        if (res) {
          SetTiles(res.data.tiles);
          setCommissionData(res.data.table_data);
          setState({
            ...state,
            data: res.data.table_data,
            pending: false,
            totalRows: res.data.count,
            types: res.data.category,
            loading: false,
          });
          setcommissionTypes(res?.data?.category);
        } else {
          if (res.error.code === 1002) {
            history.push("/logout");
          } else if (res.error.code === 1057) {
            history.push({
              pathname: "/dashboard",
              state: {
                error: true,
                message: "permissionDenied",
              },
            });
          }
        }
      });
  };

  const exportData = () => {
    alert("export data");
  };

  useEffect(() => {
    // const { selectedStartDate, selectedEndDate } = state;
    fetchReport(
      state.inPage,
      perPageRef.current,
      selectedCommissionType,
      selectedStartDateRef.current,
      selectedEndDateRef.current
    );
  }, []);

  useEffect(() => {
    const urlSearchParams = new URLSearchParams(location.search);
    const typeParam = urlSearchParams.get("type");
    if (typeParam) {
      const types = typeParam.split(",");
      setSelectedCommissionType(types);
    } else {
      setSelectedCommissionType(initialCommissionType);
      const updatedParams = new URLSearchParams(window.location.search);
      updatedParams.set("type", initialCommissionType.join(","));
      const newQueryString = updatedParams.toString();
      history.push({ search: newQueryString });
    }
  }, []);

  const changeStatementTable = (inPage, perPage) => {
    perPageRef.current = perPage;
    setState((prevState) => ({
      ...prevState,
      perPage: perPage,
      inPage: inPage,
    }));
    console.log(
      state,
      "start and end date goes here in change statement table"
    );
    fetchReport(
      inPage,
      perPage,
      selectedCommissionType,
      selectedStartDateRef.current,
      selectedEndDateRef.current
    );
  };

  const fetchReport = (
    inPage = state.inPage,
    perPage = perPageRef.current,
    selectedType = selectedCommissionType,
    start_date = state.selectedStartDate,
    end_date = state.selectedEndDate
  ) => {
    setState({
      ...state,
      loading: true,
    });

    let start = (inPage - 1) * perPage;

    service
      .getCommissionReport(start, perPage, selectedType, start_date, end_date)
      .then((res) => {
        if (res) {
          SetTiles(res.data.tiles);
          setCommissionData(res.data.table_data);
          setState({
            ...state,
            data: res.data.table_data,
            pending: false,
            totalRows: res.data.count,
            types: res.data.category,
            loading: false,
          });
          setcommissionTypes(res?.data?.category);
        } else {
          if (res.error.code === 1002) {
            history.push("/logout");
          } else if (res.error.code === 1057) {
            history.push({
              pathname: "/dashboard",
              state: {
                error: true,
                message: "permissionDenied",
              },
            });
          }
        }
      })
      .catch((error) => {
        console.error("Error fetching report:", error);
        setState({
          ...state,
          loading: false,
        });
      });
  };

  return (
    <div
      className="commission-report-container"
      style={{ boxShadow: "0px 0px 10px rgba(0, 0.1, 0.1, 0)" }}
    >
      <Helmet>
        <title>
          {companyName.companyName} | {t("Sidemenu.commissionReport")}
        </title>
      </Helmet>
      <PageTitle title="commissionReport" />
      <br />
      {/* {state.loading ? (
        <Spinner />
      ) : ( */}
      <>
        {/* <div className="selection-topdiv">
          <div>{tiles && <Tiles tilesData={tiles} />}</div>
        </div>
        <br /> */}
        <div
          style={{
            backgroundColor: "white",
            margin: "1rem",
            padding: "1.2rem",
            borderRadius: ".5rem",
            overflow: "scroll",
          }}
        >
          <Content
            tableData={state}
            loader={state.loading}
            resetdata={resetdata}
            exportData={exportData}
            datehandler={changeDate}
            printloader={printloader}
            changeOrdersTable={changeStatementTable}
            category={state.types}
            selectedCommissionType={selectedCommissionType}
            selectedStartDate={state.selectedStartDate}
            selectedEndDate={state.selectedEndDate}
          />
        </div>
      </>
      {/* )} */}
    </div>
  );
};

export default withTranslation()(
  connect(mapStateToProps)(withRouter(CommissionReport))
);
